import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _1c04964f = () => interopDefault(import('../pages/applicant-profile/index.vue' /* webpackChunkName: "pages/applicant-profile/index" */))
const _28954be8 = () => interopDefault(import('../pages/applications/index.vue' /* webpackChunkName: "pages/applications/index" */))
const _0db3e28c = () => interopDefault(import('../pages/browse.vue' /* webpackChunkName: "pages/browse" */))
const _49cc1a22 = () => interopDefault(import('../pages/browser-outdated.vue' /* webpackChunkName: "pages/browser-outdated" */))
const _a3a876fc = () => interopDefault(import('../pages/dashboard.vue' /* webpackChunkName: "pages/dashboard" */))
const _cd42fe36 = () => interopDefault(import('../pages/impressum.vue' /* webpackChunkName: "pages/impressum" */))
const _cb140d86 = () => interopDefault(import('../pages/job-offer/index.vue' /* webpackChunkName: "pages/job-offer/index" */))
const _ef189596 = () => interopDefault(import('../pages/organization.vue' /* webpackChunkName: "pages/organization" */))
const _21738cf1 = () => interopDefault(import('../pages/organization/email-templates/index.vue' /* webpackChunkName: "pages/organization/email-templates/index" */))
const _3704e4cf = () => interopDefault(import('../pages/organization/payment-incomplete.vue' /* webpackChunkName: "pages/organization/payment-incomplete" */))
const _72c51dea = () => interopDefault(import('../pages/organization/payment-past-due.vue' /* webpackChunkName: "pages/organization/payment-past-due" */))
const _043ebdc2 = () => interopDefault(import('../pages/organization/payment-paused.vue' /* webpackChunkName: "pages/organization/payment-paused" */))
const _189e716c = () => interopDefault(import('../pages/organization/pricing.vue' /* webpackChunkName: "pages/organization/pricing" */))
const _73529c62 = () => interopDefault(import('../pages/organization/profile.vue' /* webpackChunkName: "pages/organization/profile" */))
const _3e2fbb3f = () => interopDefault(import('../pages/organization/subscription-expired.vue' /* webpackChunkName: "pages/organization/subscription-expired" */))
const _6eab9e94 = () => interopDefault(import('../pages/organization/trial-expired.vue' /* webpackChunkName: "pages/organization/trial-expired" */))
const _700b8cd6 = () => interopDefault(import('../pages/organization/user.vue' /* webpackChunkName: "pages/organization/user" */))
const _34b25bed = () => interopDefault(import('../pages/organization/email-templates/create.vue' /* webpackChunkName: "pages/organization/email-templates/create" */))
const _d49bd0ce = () => interopDefault(import('../pages/organization/email-templates/_id.vue' /* webpackChunkName: "pages/organization/email-templates/_id" */))
const _8b97b778 = () => interopDefault(import('../pages/organization-create.vue' /* webpackChunkName: "pages/organization-create" */))
const _6610e238 = () => interopDefault(import('../pages/organization-unavailable.vue' /* webpackChunkName: "pages/organization-unavailable" */))
const _3434c0f6 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _59fa8c4b = () => interopDefault(import('../pages/talent-pool.vue' /* webpackChunkName: "pages/talent-pool" */))
const _02a2e616 = () => interopDefault(import('../pages/terms.vue' /* webpackChunkName: "pages/terms" */))
const _0001a0bf = () => interopDefault(import('../pages/unsubscribe.vue' /* webpackChunkName: "pages/unsubscribe" */))
const _4b408860 = () => interopDefault(import('../pages/welcome.vue' /* webpackChunkName: "pages/welcome" */))
const _9138e7c0 = () => interopDefault(import('../pages/auth/forgot-password.vue' /* webpackChunkName: "pages/auth/forgot-password" */))
const _69eccfd8 = () => interopDefault(import('../pages/auth/impersonate.vue' /* webpackChunkName: "pages/auth/impersonate" */))
const _288c0f44 = () => interopDefault(import('../pages/auth/login.vue' /* webpackChunkName: "pages/auth/login" */))
const _3606e1bf = () => interopDefault(import('../pages/auth/logout.vue' /* webpackChunkName: "pages/auth/logout" */))
const _41359318 = () => interopDefault(import('../pages/auth/register.vue' /* webpackChunkName: "pages/auth/register" */))
const _1097549b = () => interopDefault(import('../pages/auth/register.handler.js' /* webpackChunkName: "pages/auth/register.handler" */))
const _0b52090e = () => interopDefault(import('../pages/auth/reset-password.vue' /* webpackChunkName: "pages/auth/reset-password" */))
const _b6790686 = () => interopDefault(import('../pages/auth/verify-email.vue' /* webpackChunkName: "pages/auth/verify-email" */))
const _48050dbe = () => interopDefault(import('../pages/job-offer/create.vue' /* webpackChunkName: "pages/job-offer/create" */))
const _51354ff3 = () => interopDefault(import('../pages/job-offer/not-found.vue' /* webpackChunkName: "pages/job-offer/not-found" */))
const _31c01667 = () => interopDefault(import('../pages/user/profile.vue' /* webpackChunkName: "pages/user/profile" */))
const _54b0cec0 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _24e13c25 = () => interopDefault(import('../pages/assessment/applicant/_id/index.vue' /* webpackChunkName: "pages/assessment/applicant/_id/index" */))
const _cbd34822 = () => interopDefault(import('../pages/assessment/job-offer/_id/index.vue' /* webpackChunkName: "pages/assessment/job-offer/_id/index" */))
const _3d5f26a6 = () => interopDefault(import('../pages/assessment/applicant/_id/consent.vue' /* webpackChunkName: "pages/assessment/applicant/_id/consent" */))
const _416b9a89 = () => interopDefault(import('../pages/assessment/applicant/_id/results.vue' /* webpackChunkName: "pages/assessment/applicant/_id/results" */))
const _3dd7efd3 = () => interopDefault(import('../pages/assessment/job-offer/_id/results.vue' /* webpackChunkName: "pages/assessment/job-offer/_id/results" */))
const _fd7603fc = () => interopDefault(import('../pages/job-offer/apply/_organization/_jobTitleId.vue' /* webpackChunkName: "pages/job-offer/apply/_organization/_jobTitleId" */))
const _36fbf1ba = () => interopDefault(import('../pages/applicant-profile/_id/index.vue' /* webpackChunkName: "pages/applicant-profile/_id/index" */))
const _5937b62c = () => interopDefault(import('../pages/application/_id/index.vue' /* webpackChunkName: "pages/application/_id/index" */))
const _bc71e632 = () => interopDefault(import('../pages/assessment-invitation/_token.vue' /* webpackChunkName: "pages/assessment-invitation/_token" */))
const _5a7e1252 = () => interopDefault(import('../pages/applicant-profile/_id/edit.vue' /* webpackChunkName: "pages/applicant-profile/_id/edit" */))
const _39b41355 = () => interopDefault(import('../pages/applicant-profile/_id/edit/index.vue' /* webpackChunkName: "pages/applicant-profile/_id/edit/index" */))
const _44fca4a8 = () => interopDefault(import('../pages/applicant-profile/_id/edit/criteria.vue' /* webpackChunkName: "pages/applicant-profile/_id/edit/criteria" */))
const _c056ecaa = () => interopDefault(import('../pages/applicant-profile/_id/edit/education.vue' /* webpackChunkName: "pages/applicant-profile/_id/edit/education" */))
const _141f9e12 = () => interopDefault(import('../pages/applicant-profile/_id/edit/experience.vue' /* webpackChunkName: "pages/applicant-profile/_id/edit/experience" */))
const _7f812caa = () => interopDefault(import('../pages/applicant-profile/_id/edit/general.vue' /* webpackChunkName: "pages/applicant-profile/_id/edit/general" */))
const _3245889e = () => interopDefault(import('../pages/applicant-profile/_id/edit/languages.vue' /* webpackChunkName: "pages/applicant-profile/_id/edit/languages" */))
const _6ab5eab1 = () => interopDefault(import('../pages/applicant-profile/_id/edit/personality.vue' /* webpackChunkName: "pages/applicant-profile/_id/edit/personality" */))
const _78039436 = () => interopDefault(import('../pages/applicant-profile/_id/setup.vue' /* webpackChunkName: "pages/applicant-profile/_id/setup" */))
const _5d81fca8 = () => interopDefault(import('../pages/applicant-profile/_id/setup/index.vue' /* webpackChunkName: "pages/applicant-profile/_id/setup/index" */))
const _74a4df79 = () => interopDefault(import('../pages/applicant-profile/_id/setup/criteria.vue' /* webpackChunkName: "pages/applicant-profile/_id/setup/criteria" */))
const _12c516e4 = () => interopDefault(import('../pages/applicant-profile/_id/setup/documents.vue' /* webpackChunkName: "pages/applicant-profile/_id/setup/documents" */))
const _25d0dd04 = () => interopDefault(import('../pages/applicant-profile/_id/setup/education.vue' /* webpackChunkName: "pages/applicant-profile/_id/setup/education" */))
const _510e2384 = () => interopDefault(import('../pages/applicant-profile/_id/setup/experience.vue' /* webpackChunkName: "pages/applicant-profile/_id/setup/experience" */))
const _e3249d8c = () => interopDefault(import('../pages/applicant-profile/_id/setup/experience-choice.vue' /* webpackChunkName: "pages/applicant-profile/_id/setup/experience-choice" */))
const _28384a3e = () => interopDefault(import('../pages/applicant-profile/_id/setup/general.vue' /* webpackChunkName: "pages/applicant-profile/_id/setup/general" */))
const _7f889071 = () => interopDefault(import('../pages/applicant-profile/_id/setup/languages.vue' /* webpackChunkName: "pages/applicant-profile/_id/setup/languages" */))
const _2900a998 = () => interopDefault(import('../pages/applicant-profile/_id/setup/linkedin.vue' /* webpackChunkName: "pages/applicant-profile/_id/setup/linkedin" */))
const _1218de65 = () => interopDefault(import('../pages/applicant-profile/_id/setup/linkedin-consent.vue' /* webpackChunkName: "pages/applicant-profile/_id/setup/linkedin-consent" */))
const _4660debe = () => interopDefault(import('../pages/invitation/_id/accept.vue' /* webpackChunkName: "pages/invitation/_id/accept" */))
const _b134beb8 = () => interopDefault(import('../pages/job-offer/_id/edit.vue' /* webpackChunkName: "pages/job-offer/_id/edit" */))
const _b80fc7b2 = () => interopDefault(import('../pages/job-offer/_id/edit/index.vue' /* webpackChunkName: "pages/job-offer/_id/edit/index" */))
const _77384d06 = () => interopDefault(import('../pages/job-offer/_id/edit/education.vue' /* webpackChunkName: "pages/job-offer/_id/edit/education" */))
const _acb6f406 = () => interopDefault(import('../pages/job-offer/_id/edit/general.vue' /* webpackChunkName: "pages/job-offer/_id/edit/general" */))
const _56d4d870 = () => interopDefault(import('../pages/job-offer/_id/edit/languages.vue' /* webpackChunkName: "pages/job-offer/_id/edit/languages" */))
const _ae9ee3fa = () => interopDefault(import('../pages/job-offer/_id/edit/personality.vue' /* webpackChunkName: "pages/job-offer/_id/edit/personality" */))
const _568cc26a = () => interopDefault(import('../pages/job-offer/_id/edit/requirements.vue' /* webpackChunkName: "pages/job-offer/_id/edit/requirements" */))
const _27adb9fc = () => interopDefault(import('../pages/job-offer/_id/view/index.vue' /* webpackChunkName: "pages/job-offer/_id/view/index" */))
const _449d6703 = () => interopDefault(import('../pages/job-offer/_id/create/description.vue' /* webpackChunkName: "pages/job-offer/_id/create/description" */))
const _07e2d1c9 = () => interopDefault(import('../pages/job-offer/_id/create/details.vue' /* webpackChunkName: "pages/job-offer/_id/create/details" */))
const _ab8158ea = () => interopDefault(import('../pages/job-offer/_id/create/permissions.vue' /* webpackChunkName: "pages/job-offer/_id/create/permissions" */))
const _49c6d699 = () => interopDefault(import('../pages/job-offer/_id/create/requirements.vue' /* webpackChunkName: "pages/job-offer/_id/create/requirements" */))
const _13a5b3be = () => interopDefault(import('../pages/job-offer/_id/create/review.vue' /* webpackChunkName: "pages/job-offer/_id/create/review" */))
const _7bc477d4 = () => interopDefault(import('../pages/job-offer/_id/quiz/manual.vue' /* webpackChunkName: "pages/job-offer/_id/quiz/manual" */))
const _b2072f6e = () => interopDefault(import('../pages/job-offer/_id/view/job-profile.vue' /* webpackChunkName: "pages/job-offer/_id/view/job-profile" */))
const _a2dc1316 = () => interopDefault(import('../pages/job-offer/_id/view/work-style.vue' /* webpackChunkName: "pages/job-offer/_id/view/work-style" */))
const _3ecd6a3a = () => interopDefault(import('../pages/job-offer/_id/_slug/index.vue' /* webpackChunkName: "pages/job-offer/_id/_slug/index" */))
const _52fa2d78 = () => interopDefault(import('../pages/_slug.vue' /* webpackChunkName: "pages/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/applicant-profile",
    component: _1c04964f,
    name: "applicant-profile"
  }, {
    path: "/applications",
    component: _28954be8,
    name: "applications"
  }, {
    path: "/browse",
    component: _0db3e28c,
    name: "browse"
  }, {
    path: "/browser-outdated",
    component: _49cc1a22,
    name: "browser-outdated"
  }, {
    path: "/dashboard",
    component: _a3a876fc,
    name: "dashboard"
  }, {
    path: "/impressum",
    component: _cd42fe36,
    name: "impressum"
  }, {
    path: "/job-offer",
    component: _cb140d86,
    name: "job-offer"
  }, {
    path: "/organization",
    component: _ef189596,
    name: "organization",
    children: [{
      path: "email-templates",
      component: _21738cf1,
      name: "organization-email-templates"
    }, {
      path: "payment-incomplete",
      component: _3704e4cf,
      name: "organization-payment-incomplete"
    }, {
      path: "payment-past-due",
      component: _72c51dea,
      name: "organization-payment-past-due"
    }, {
      path: "payment-paused",
      component: _043ebdc2,
      name: "organization-payment-paused"
    }, {
      path: "pricing",
      component: _189e716c,
      name: "organization-pricing"
    }, {
      path: "profile",
      component: _73529c62,
      name: "organization-profile"
    }, {
      path: "subscription-expired",
      component: _3e2fbb3f,
      name: "organization-subscription-expired"
    }, {
      path: "trial-expired",
      component: _6eab9e94,
      name: "organization-trial-expired"
    }, {
      path: "user",
      component: _700b8cd6,
      name: "organization-user"
    }, {
      path: "email-templates/create",
      component: _34b25bed,
      name: "organization-email-templates-create"
    }, {
      path: "email-templates/:id?",
      component: _d49bd0ce,
      name: "organization-email-templates-id"
    }]
  }, {
    path: "/organization-create",
    component: _8b97b778,
    name: "organization-create"
  }, {
    path: "/organization-unavailable",
    component: _6610e238,
    name: "organization-unavailable"
  }, {
    path: "/privacy",
    component: _3434c0f6,
    name: "privacy"
  }, {
    path: "/talent-pool",
    component: _59fa8c4b,
    name: "talent-pool"
  }, {
    path: "/terms",
    component: _02a2e616,
    name: "terms"
  }, {
    path: "/unsubscribe",
    component: _0001a0bf,
    name: "unsubscribe"
  }, {
    path: "/welcome",
    component: _4b408860,
    name: "welcome"
  }, {
    path: "/auth/forgot-password",
    component: _9138e7c0,
    name: "auth-forgot-password"
  }, {
    path: "/auth/impersonate",
    component: _69eccfd8,
    name: "auth-impersonate"
  }, {
    path: "/auth/login",
    component: _288c0f44,
    name: "auth-login"
  }, {
    path: "/auth/logout",
    component: _3606e1bf,
    name: "auth-logout"
  }, {
    path: "/auth/register",
    component: _41359318,
    name: "auth-register"
  }, {
    path: "/auth/register.handler",
    component: _1097549b,
    name: "auth-register.handler"
  }, {
    path: "/auth/reset-password",
    component: _0b52090e,
    name: "auth-reset-password"
  }, {
    path: "/auth/verify-email",
    component: _b6790686,
    name: "auth-verify-email"
  }, {
    path: "/job-offer/create",
    component: _48050dbe,
    name: "job-offer-create"
  }, {
    path: "/job-offer/not-found",
    component: _51354ff3,
    name: "job-offer-not-found"
  }, {
    path: "/user/profile",
    component: _31c01667,
    name: "user-profile"
  }, {
    path: "/",
    component: _54b0cec0,
    name: "index"
  }, {
    path: "/assessment/applicant/:id",
    component: _24e13c25,
    name: "assessment-applicant-id"
  }, {
    path: "/assessment/job-offer/:id",
    component: _cbd34822,
    name: "assessment-job-offer-id"
  }, {
    path: "/assessment/applicant/:id?/consent",
    component: _3d5f26a6,
    name: "assessment-applicant-id-consent"
  }, {
    path: "/assessment/applicant/:id?/results",
    component: _416b9a89,
    name: "assessment-applicant-id-results"
  }, {
    path: "/assessment/job-offer/:id?/results",
    component: _3dd7efd3,
    name: "assessment-job-offer-id-results"
  }, {
    path: "/job-offer/apply/:organization/:jobTitleId?",
    component: _fd7603fc,
    name: "job-offer-apply-organization-jobTitleId"
  }, {
    path: "/applicant-profile/:id",
    component: _36fbf1ba,
    name: "applicant-profile-id"
  }, {
    path: "/application/:id",
    component: _5937b62c,
    name: "application-id"
  }, {
    path: "/assessment-invitation/:token?",
    component: _bc71e632,
    name: "assessment-invitation-token"
  }, {
    path: "/applicant-profile/:id?/edit",
    component: _5a7e1252,
    children: [{
      path: "",
      component: _39b41355,
      name: "applicant-profile-id-edit"
    }, {
      path: "criteria",
      component: _44fca4a8,
      name: "applicant-profile-id-edit-criteria"
    }, {
      path: "education",
      component: _c056ecaa,
      name: "applicant-profile-id-edit-education"
    }, {
      path: "experience",
      component: _141f9e12,
      name: "applicant-profile-id-edit-experience"
    }, {
      path: "general",
      component: _7f812caa,
      name: "applicant-profile-id-edit-general"
    }, {
      path: "languages",
      component: _3245889e,
      name: "applicant-profile-id-edit-languages"
    }, {
      path: "personality",
      component: _6ab5eab1,
      name: "applicant-profile-id-edit-personality"
    }]
  }, {
    path: "/applicant-profile/:id?/setup",
    component: _78039436,
    children: [{
      path: "",
      component: _5d81fca8,
      name: "applicant-profile-id-setup"
    }, {
      path: "criteria",
      component: _74a4df79,
      name: "applicant-profile-id-setup-criteria"
    }, {
      path: "documents",
      component: _12c516e4,
      name: "applicant-profile-id-setup-documents"
    }, {
      path: "education",
      component: _25d0dd04,
      name: "applicant-profile-id-setup-education"
    }, {
      path: "experience",
      component: _510e2384,
      name: "applicant-profile-id-setup-experience"
    }, {
      path: "experience-choice",
      component: _e3249d8c,
      name: "applicant-profile-id-setup-experience-choice"
    }, {
      path: "general",
      component: _28384a3e,
      name: "applicant-profile-id-setup-general"
    }, {
      path: "languages",
      component: _7f889071,
      name: "applicant-profile-id-setup-languages"
    }, {
      path: "linkedin",
      component: _2900a998,
      name: "applicant-profile-id-setup-linkedin"
    }, {
      path: "linkedin-consent",
      component: _1218de65,
      name: "applicant-profile-id-setup-linkedin-consent"
    }]
  }, {
    path: "/invitation/:id?/accept",
    component: _4660debe,
    name: "invitation-id-accept"
  }, {
    path: "/job-offer/:id?/edit",
    component: _b134beb8,
    children: [{
      path: "",
      component: _b80fc7b2,
      name: "job-offer-id-edit"
    }, {
      path: "education",
      component: _77384d06,
      name: "job-offer-id-edit-education"
    }, {
      path: "general",
      component: _acb6f406,
      name: "job-offer-id-edit-general"
    }, {
      path: "languages",
      component: _56d4d870,
      name: "job-offer-id-edit-languages"
    }, {
      path: "personality",
      component: _ae9ee3fa,
      name: "job-offer-id-edit-personality"
    }, {
      path: "requirements",
      component: _568cc26a,
      name: "job-offer-id-edit-requirements"
    }]
  }, {
    path: "/job-offer/:id?/view",
    component: _27adb9fc,
    name: "job-offer-id-view"
  }, {
    path: "/job-offer/:id?/create/description",
    component: _449d6703,
    name: "job-offer-id-create-description"
  }, {
    path: "/job-offer/:id?/create/details",
    component: _07e2d1c9,
    name: "job-offer-id-create-details"
  }, {
    path: "/job-offer/:id?/create/permissions",
    component: _ab8158ea,
    name: "job-offer-id-create-permissions"
  }, {
    path: "/job-offer/:id?/create/requirements",
    component: _49c6d699,
    name: "job-offer-id-create-requirements"
  }, {
    path: "/job-offer/:id?/create/review",
    component: _13a5b3be,
    name: "job-offer-id-create-review"
  }, {
    path: "/job-offer/:id?/quiz/manual",
    component: _7bc477d4,
    name: "job-offer-id-quiz-manual"
  }, {
    path: "/job-offer/:id?/view/job-profile",
    component: _b2072f6e,
    name: "job-offer-id-view-job-profile"
  }, {
    path: "/job-offer/:id?/view/work-style",
    component: _a2dc1316,
    name: "job-offer-id-view-work-style"
  }, {
    path: "/job-offer/:id?/:slug",
    component: _3ecd6a3a,
    name: "job-offer-id-slug"
  }, {
    path: "/:slug",
    component: _52fa2d78,
    name: "slug"
  }, {
    path: "/message",
    redirect: (to) => ({
            path: '/applications/',
            query: { ...to.query }
          })
  }, {
    path: "/message/applications",
    redirect: (to) => ({
            path: '/applications/',
            query: { ...to.query }
          })
  }, {
    path: "/message/pending",
    redirect: (to) => ({
            path: '/applications/',
            query: {
              ...to.query,
              status: to.query.status || 'pending'
            }
          })
  }, {
    path: "/message/accepted",
    redirect: (to) => ({
            path: '/applications/',
            query: {
              ...to.query,
              status: to.query.status || 'accepted'
            }
          })
  }, {
    path: "/message/interview",
    redirect: (to) => ({
            path: '/applications/',
            query: {
              ...to.query,
              status: to.query.status || 'interview'
            }
          })
  }, {
    path: "/message/hired",
    redirect: (to) => ({
            path: '/applications/',
            query: {
              ...to.query,
              status: to.query.status || 'hired'
            }
          })
  }, {
    path: "/message/denied",
    redirect: (to) => ({
            path: '/applications/',
            query: {
              ...to.query,
              status: to.query.status || 'denied'
            }
          })
  }, {
    path: "/message/denied-applicant",
    redirect: (to) => ({
            path: '/applications/',
            query: {
              ...to.query,
              status: to.query.status || 'denied'
            }
          })
  }, {
    path: "/message/invites",
    redirect: (to) => ({
            path: '/applications/',
            query: {
              ...to.query,
              status: to.query.status || 'invitation'
            }
          })
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
